import crypto from 'crypto-browserify';
import { apiSec } from './environment';

/**
 * -------- IMPORTANT SECURITY NOTICE --------
 *
 * We deliberately pin **crypto-browserify @ 3.12.0** because the newer 3.12.1
 * requires a Webpack ‘vm’ polyfill that is not yet wired up in this app. Implementing this 
 * would require new dependencies and in the interest of minimizing work required to keep this application up to date, we have chosen to pin to 3.12.0.
 *
 * 3.12.0 pulls in elliptic ≤ 6.5.6, which has an ECDSA/EdDSA signature-malleability
 * vulnerability (CVE-2024-42460 / CVE-2024-42461).  Our code only generates an
 * HMAC with SHA-256 (`crypto.createHmac`)—we do not verify ECDSA/EdDSA
 * signatures—so the flaw is currently not exploitable here.
 *
 * If you later add any feature that verifies curve signatures (JWT, WebAuthn,
 * OAuth, etc.) you must either upgrade to crypto-browserify ≥ 3.12.1
 * and add a ‘vm’ shim, or switch to another modern crypto API
 * (`window.crypto.subtle`).
 *
 * Reference: GitHub Advisory for elliptic BER-encoded signature malleability  
 * https://github.com/advisories/GHSA-49q7-c7j4-3p7m
 */


/**
 * Function to generate a unique and verifiable signature for any request body
 * @param req request body to sign
 */
export default function signRequest (uuid: string, date: string) {
    // Create URI string combining signature data
    let sigData = 'uuid=' + uuid + '&date=' + date;

    // Encrypt using SHA-1 and shared secret
    let sig = crypto.createHmac('sha256', apiSec)
                .update(sigData)
                .digest('hex');

    return sig;
}